import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '@/services/subscription';

export function useMySubscription() {
  return useQuery({
    queryKey: ['my-subscription'],
    queryFn: subscriptionService.getMySubscription,
    retry: false, // Si no tiene suscripción configurada (404), no reintentar
  });
}

export function useReportPayment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => subscriptionService.reportPayment(),
    onSuccess: (data) => {
      queryClient.setQueryData(['my-subscription'], data);
    },
  });
}
